



















import {Vue, Component, Prop} from 'vue-property-decorator'
import {Action, Mutation} from "vuex-class";

@Component
export default class ZwlTabs extends Vue {
  @Prop({default: true}) hasQuery!: boolean
  @Prop({default: 0}) active!: number
  @Prop({default: () => []}) theme!: object

  searchContent: string = ''
  @Mutation setActiveTab
  @Action getTabArticle
  @Action getSearchArticle

  handleChangeTheme(val) {
    this.$emit('change', val)
  }
  
  doSearch() {
    this.$emit('change', -1)
    this.setActiveTab({})
    this.$Modal.confirm({
      render: (h) => {
        return h('Input', {
          props: {
            value: this.searchContent,
            autofocus: true,
            placeholder: '请输入搜索的内容...'
          },
          on: {
            input: (val) => {
              this.searchContent = val
            }
          }
        })
      },
      onOk: () => {
        this.getSearchArticle(this.searchContent)
      }
    })
  }
}
